
  export const OtherEnrollmentConditionId = 11;